import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ZegoUIKitPrebuilt } from "@zegocloud/zego-uikit-prebuilt";
import { useAuth } from "../../../provider/authProvider";
import { getAppIdNSecrets, updatePendingBookingAmount } from "../../../ApiServices/ApiServices";
import { handleError } from "../../../Utils";

const Room = () => {
  
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const id = queryParams.get("id");
  const meetingId = queryParams.get("meetingId");
  const name = queryParams.get("name");
  const role = queryParams.get("role");
  const hasCalled = useRef(false);

  const meetingContainerRef = useRef(null);
  const roomJoinedRef = useRef(false);
  const navigateTo = useNavigate();
  const [appId, setAppId] = useState("");
  const [serverSecrets, setServerSecrets] = useState("");

  useEffect(() => {
    const fetchAppIdAndServerSecrets = async() =>{
      if(hasCalled.current) return ;
      hasCalled.current = true;
      try {
        const res = await getAppIdNSecrets();
        setAppId(res?.appId);
        setServerSecrets(res?.serverSecret)
      } catch (error) {
        return handleError(error?.response?.data?.message);
      }
    }
    fetchAppIdAndServerSecrets();
  }, [])

  useEffect(() => {
    const myMeeting = async () => {
      if (roomJoinedRef.current || !appId || !serverSecrets) return null;
      roomJoinedRef.current = true;

      // generate Kit Token
      const appID = parseInt(appId);
      const serverSecret = serverSecrets;
      const kitToken = ZegoUIKitPrebuilt.generateKitTokenForTest(
        appID,
        serverSecret,
        meetingId,
        Date.now().toString(), // userid
        name // user name
      );

      // Create instance object from Kit Token
      const zp = ZegoUIKitPrebuilt.create(kitToken);

      // Start the call
      zp.joinRoom({
        container: meetingContainerRef.current,
        sharedLinks: [
          {
            name: "Personal link",
            url: `${window.location.origin}/room/?meetingId=${meetingId}&id=${id}&name=${name}&role=${role}`,
          },
        ],
        scenario: {
          mode: ZegoUIKitPrebuilt.OneONoneCall,
        },
        onUserJoin: async () => {
          if (role === "mentor") {
            await updatePendingBookingAmount(id);
          }
        },
        onLeaveRoom: async () => {
          if(role==='user'){
            const url = `review/?id=${id}`;
            window.open(url, '_blank');
          }
        },
      });
    };

    myMeeting();
  }, [id, appId, serverSecrets]);

  // Inline styles for container and video
  const containerStyle = {
    position: "relative",
    width: "100%",
    height: "100vh",
  };

  const videoStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  };

  return (
    <div
      className="myCallContainer"
      ref={meetingContainerRef}
      style={containerStyle}
    >
      {/* {<video style={videoStyle}></video>} */}
    </div>
  );
};

export default Room;
